import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Image } from "react-bootstrap";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import DescriptionIcon from "@mui/icons-material/Description";
export default function DownloadFile(param) {
    var urlPath = param.urlPath, fileName = param.fileName, _param_showIcon = param.showIcon, showIcon = _param_showIcon === void 0 ? false : _param_showIcon, _param_showIconFile = param.showIconFile, showIconFile = _param_showIconFile === void 0 ? false : _param_showIconFile, _param_showText = param.showText, showText = _param_showText === void 0 ? false : _param_showText;
    var checkType = CheckType(urlPath);
    var chkFileName = fileName && fileName != "" && fileName != null ? fileName.split(".") : [];
    var newFileName = fileName && chkFileName && chkFileName.length > 1 ? fileName : fileName && chkFileName && chkFileName.length <= 1 && fileName != "" && fileName != null ? fileName + "." + checkType.typeFile : chkFileName && checkType.fileName != "" && checkType.fileName != null && (!fileName || fileName == "" || fileName == null) ? checkType.fileName : "downloaded-file." + checkType.typeFile;
    var handleDownload = function() {
        fetch(urlPath).then(function(response) {
            return response.blob();
        }).then(function(blob) {
            var urlPath = window.URL.createObjectURL(new Blob([
                blob
            ]));
            var link = document.createElement("a");
            link.href = urlPath;
            link.download = newFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlPath);
        }).catch(function(error) {
            console.error("Error fetching the file:", error);
        });
    };
    return showIcon ? /*#__PURE__*/ _jsxs(Button, {
        variant: "link",
        onClick: handleDownload,
        children: [
            checkType && (checkType.typeFile == "pdf" || checkType.typeFile == "PDF") ? /*#__PURE__*/ _jsx(PictureAsPdfIcon, {
                sx: {
                    color: "#ff0000"
                },
                className: "mr-1"
            }) : checkType && (checkType.typeFile == "png" || checkType.typeFile == "jpeg" || checkType.typeFile == "gif" || checkType.typeFile == "jpg" || checkType.typeFile == "webp") ? /*#__PURE__*/ _jsx(PermMediaIcon, {
                sx: {
                    color: "#ff0000"
                },
                className: "mr-1"
            }) : /*#__PURE__*/ _jsx(FileDownloadIcon, {
                sx: {
                    color: "#ff0000"
                },
                className: "mr-1"
            }),
            newFileName && newFileName != "" && newFileName != null && newFileName != "null" ? newFileName : ""
        ]
    }) : showIconFile ? /*#__PURE__*/ _jsx(Button, {
        variant: "link",
        onClick: handleDownload,
        className: "m-0 p-0",
        children: /*#__PURE__*/ _jsx(DescriptionIcon, {
            sx: {
                color: "#ff0000",
                fontSize: "100px"
            }
        })
    }) : showText ? /*#__PURE__*/ _jsx(Button, {
        variant: "link",
        onClick: handleDownload,
        className: "m-0 p-0",
        style: {
            maxWidth: "100%"
        },
        children: /*#__PURE__*/ _jsx("span", {
            className: "d-inline-block text-truncate",
            style: {
                maxWidth: "100%",
                fontSize: "smaller"
            },
            children: newFileName && newFileName != "" && newFileName != null && newFileName != "null" ? newFileName : ""
        })
    }) : /*#__PURE__*/ _jsx("button", {
        className: "btn btn-export-st-1 me-auto",
        onClick: handleDownload,
        children: "Export"
    });
}
function CheckType() {
    var strUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var typeFile = {};
    if (strUrl && strUrl != "" && strUrl != null && strUrl != "null") {
        var strUrl_array = strUrl.split("/");
        if (strUrl_array && strUrl_array.length > 0) {
            var typeFile_array = strUrl_array[strUrl_array.length - 1].split(".");
            if (typeFile_array && typeFile_array.length > 0) {
                typeFile.fileName = strUrl_array[strUrl_array.length - 1];
                typeFile.typeFile = typeFile_array[typeFile_array.length - 1].toLowerCase();
            }
        }
    } else {
        typeFile.fileName = "";
        typeFile.typeFile = "";
    }
    return typeFile;
}
function CheckFileName() {
    var strUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var typeFile = "";
    if (strUrl && strUrl != "" && strUrl != null && strUrl != "null") {
        var strUrl_array = strUrl.split("/");
        if (strUrl_array && strUrl_array.length > 0) {
            var typeFile_array = strUrl_array[strUrl_array.length - 1].split(".");
            if (typeFile_array && typeFile_array.length > 0) {
                typeFile = typeFile_array[typeFile_array.length - 1].toLowerCase();
            }
        }
    } else {
        typeFile = "";
    }
    return typeFile;
}
